import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function OrthopaedicConsultation() {
  useEffect(() => {
    document.title = "Orthopaedic Consultation | Viksha Health Care";
    const newMetaDescription =
      "Orthopaedic consultation at Viksha Health Care for bone, joint, muscle and ligament problems. Get a clear diagnosis and personalized next steps.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Orthopaedic Consultation</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Orthopaedic-Consultation.avif" />
        </div>
        <div className="textareaofser">
          <h1>Orthopaedic Consultation</h1>

          <p>
            An orthopaedic consultation helps evaluate problems related to
            bones, joints, muscles, ligaments, and tendons. If you are
            experiencing pain, swelling, stiffness, or difficulty in movement, a
            consultation can help identify the cause and guide you toward the
            right treatment.
          </p>

          <p>
            Whether the problem is due to injury, overuse, age-related changes,
            or a chronic condition, a timely orthopaedic evaluation can prevent
            complications and support faster recovery.
          </p>

          <h5>What Happens During an Orthopaedic Consultation?</h5>

          <h6>Symptom Discussion</h6>
          <p>
            The consultation begins with a detailed discussion about your
            symptoms, their duration, how they started, and how they affect your
            daily activities. Your medical history, occupation, sports
            participation, and lifestyle factors are also reviewed.
          </p>

          <h6>Physical Examination</h6>
          <p>
            A focused examination of the affected area helps assess joint
            movement, muscle strength, alignment, and areas of tenderness or
            swelling. Your posture and walking pattern may also be evaluated
            when relevant.
          </p>

          <h6>Diagnostic Tests (If Needed)</h6>
          <p>
            Based on your condition, imaging tests such as X-rays or other scans
            may be advised to confirm the diagnosis and understand the extent of
            the problem. These tests help in planning accurate and effective
            treatment.
          </p>

          <h5>Common Reasons for an Orthopaedic Consultation</h5>
          <ul>
            <li>Persistent joint or muscle pain</li>
            <li>Back or neck pain</li>
            <li>Sports injuries or ligament strains</li>
            <li>Fractures or trauma-related pain</li>
            <li>Swelling or stiffness in joints</li>
            <li>Difficulty walking or performing daily activities</li>
            <li>Reduced range of motion in any joint</li>
          </ul>

          <h5>What You Can Expect After the Consultation</h5>
          <p>
            Once the evaluation is complete, a personalized treatment plan is
            discussed. This may include medications, physiotherapy, activity
            modification, joint support devices, or further procedures if
            required.
          </p>

          <h5>Non-Surgical Care Guidance</h5>
          <p>
            Many orthopaedic conditions improve with conservative treatment.
            Advice on exercises, posture correction, weight management, and safe
            activity levels plays a major role in recovery.
          </p>

          <h5>When Further Treatment Is Needed</h5>
          <p>
            If symptoms do not improve with initial treatment or if there is
            significant structural damage, additional interventions such as
            injections or surgical procedures may be discussed.
          </p>

          <h5>Importance of Early Consultation</h5>
          <p>
            Early orthopaedic consultation can prevent worsening of injuries,
            reduce long-term joint damage, and help you recover faster.
            Addressing symptoms early often leads to better outcomes and quicker
            return to normal activities.
          </p>

          <h5>Who Should Consider an Orthopaedic Consultation?</h5>
          <ul>
            <li>Individuals with long-standing joint or back pain</li>
            <li>People with recent injuries or falls</li>
            <li>Sports enthusiasts with recurring strains or pain</li>
            <li>Older adults with stiffness or mobility issues</li>
          </ul>

          <p>
            If you have ongoing bone, joint, or muscle discomfort, an
            orthopaedic consultation can provide clarity, reassurance, and the
            right direction for recovery.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(OrthopaedicConsultation);
